import React from 'react';
import { Award, BookOpen, Star, ShieldCheck, GraduationCap, Users } from 'lucide-react';

const credentials = [
  {
    icon: GraduationCap,
    abbr: 'DMD',
    title: 'Doctor of Dental Medicine',
    body: 'Nova Southeastern University College of Dental Medicine',
  },
  {
    icon: Star,
    abbr: 'MAGD',
    title: 'Mastership — Academy of General Dentistry',
    body: 'MAGD is a mastership designation from the Academy of General Dentistry.',
  },
  {
    icon: ShieldCheck,
    abbr: 'DABOI/ID',
    title: 'Diplomate — American Board of Oral Implantology / Implant Dentistry',
    body: 'DABOI/ID identifies diplomate status and board certification through the American Board of Oral Implantology/Implant Dentistry.',
  },
  {
    icon: Award,
    abbr: 'FAAID',
    title: 'Fellow — American Academy of Implant Dentistry',
    body: 'FAAID identifies fellowship in the American Academy of Implant Dentistry.',
  },
  {
    icon: BookOpen,
    abbr: 'DICOI',
    title: 'Diplomate — International Congress of Oral Implantologists',
    body: 'DICOI identifies a diplomate designation through the International Congress of Oral Implantologists.',
  },
  {
    icon: Users,
    abbr: 'Credentials',
    title: 'Understanding the designations',
    body: 'DMD is a dental degree; MAGD is a mastership; DABOI/ID and DICOI are diplomate designations; FAAID is a fellowship.',
  },
];

export default function DrCredentials() {
  return (
    <section className="bg-slate-900 py-20 px-4">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-amber-400 uppercase tracking-widest text-xs font-semibold mb-3">
            Professional Credentials
          </p>
          <h2 className="text-2xl md:text-4xl font-light text-white mb-4 break-words">
            Dr. Xhoana Gjelaj,{' '}
            <span className="font-semibold">DMD, MAGD, DABOI/ID, FAAID, DICOI</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-base leading-relaxed">
            Dr. Gjelaj’s professional credentials are explained below. The degree, mastership, diplomate designations and fellowship each have a distinct meaning.
          </p>
        </div>

        {/* Credential Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-14">
          {credentials.map(({ icon: Icon, abbr, title, body }) => (
            <div
              key={abbr}
              className="bg-slate-800 border border-slate-700 rounded-xl p-6 flex flex-col gap-3 hover:border-amber-400/50 transition-colors duration-200"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-amber-400/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-5 h-5 text-amber-400" />
                </div>
                <span className="text-amber-400 font-bold text-sm tracking-wide">{abbr}</span>
              </div>
              <p className="text-white font-medium text-sm leading-snug">{title}</p>
              <p className="text-slate-400 text-sm leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div className="border-t border-slate-700 pt-10 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-white font-medium text-lg mb-1">Ready to meet Dr. Gjelaj?</p>
            <p className="text-slate-400 text-sm">
              Your results start here — a $300 Signature Consult with Dr. Gjelaj that includes 3D CBCT imaging, smile design, and a written treatment plan, credited in full toward treatment begun within 30 days.
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <a
              href="/meet-the-doctor"
              className="px-5 py-2.5 border border-slate-600 text-slate-300 rounded-lg text-sm font-medium hover:border-slate-400 hover:text-white transition-colors"
            >
              Meet the Doctor
            </a>
            <a
              href="/book-appointment#signature-consult"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-amber-400 text-slate-900 rounded-lg text-sm font-semibold hover:bg-amber-300 transition-colors"
            >
              Book Consult
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}